module.exports = __webpack_public_path__ + "40f6cfbb5d75dcbd15eff31c2f16a1e7.jpg";